import BaseState from '@state/BaseState'
import GameStatesEnum from "../GameStatesEnum";
import { Signals} from "@/Imports";

export default class FreeSpinsIntroState extends BaseState {
  begin() {
    this.model.isFreespinsStarted = true
    this.model.isFreespinsMode = true

    Signals.introFreespinsComplete.addOnce(this.onIntroFreespinsComplete, this)
    Signals.introFreespins.dispatch()

    // Stop autospins
    document.dispatchEvent(new CustomEvent("setAutospinStop"))
    Signals.stopAutoplay.dispatch(true);
  }

  onIntroFreespinsComplete = () => {
    this.end()
  }

  end = () => {
    this.stateMachine.setState(GameStatesEnum.FINAL)
  }

  cleanUp() {
    Signals.introFreespinsComplete.remove(this.end, this)
  }
}
